var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0552 0.53921C10.5329 -0.0150231 9.69092 -0.0150231 9.16867 0.53921L0.311751 9.93855C-0.103917 10.3797 -0.103917 11.0923 0.311751 11.5334L9.16867 20.9327C9.69092 21.487 10.5329 21.487 11.0552 20.9327C11.5774 20.3785 11.5774 19.4849 11.0552 18.9307L3.33866 10.7303L11.0658 2.52993C11.5774 1.987 11.5774 1.08213 11.0552 0.53921Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.7dc49384bad0500b91806ed83a2b1525.svg";
export { ForwardRef as ReactComponent };